<ng-template #recipeTitleSubtitle>
  <strong class="text-base leading-snug">{{_recipe?.displayname}}</strong>
  <div class="flex flex-row flex-wrap justify-between gap-1">
    <span class="text-left text-sm leading-snug">{{_recipe?.subtitle}}</span>
    @if (_recipe?.label) {
    <span class="flex flex-row justify-end flex-grow">
      <span class="bg-e-orange text-white rounded-full px-2 py-0.5 text-sm whitespace-nowrap">
        {{_recipe?.label}}
      </span>
    </span>
    }
  </div>

</ng-template>


<div class="{{scheme[colorscheme]}} flex w-full flex-col items-stretch rounded-xl">
  <div class="relative">
    @if(overlappingAllergens()?.length > 0){
    <span class="absolute top-[15px] left-[15px] rounded-full bg-e-gold text-white px-3 py-[5px]">
      {{'common.contains' | translate}}
      @for (allergen of overlappingAllergens(); track $index; let last = $last) {
      {{'allergen.' + allergen | translate | lowercase}} @if (!last) {,}
      }
    </span>
    }

    <!-- @if (_recipe?.salessurcharge && calculatedPrice) {
    @if (_recipe?.salessurcharge > 0) {
    <span class="absolute bottom-[15px] left-[15px] rounded-full bg-e-orange text-e-white px-3 py-1 font-sans">
       +{{calculatedPrice?.priceincvat |currency: 'EUR':'symbol':'.2-2':'nl'}} {{'common.pp_abbr'| translate}}
    </span>
    }
    } -->

    @if (!disableShowRecipeAction) {
    <app-image size="md" (click)="showRecipeAction()" [imageobject]="_recipe" alt="{{_recipe?.displayname}}"
      class="h-[200px] w-full cursor-pointer rounded-t-xl object-cover object-top"></app-image>
    }@else{
    <a [routerLink]="[_recipe?.recipeurl]">
      <app-image size="md" [imageobject]="_recipe" alt="{{_recipe?.displayname}}" class="h-[200px] w-full rounded-t-xl object-cover object-top"></app-image>
    </a>
    }
  </div>

  <div class="p-[15px] flex h-full flex-col justify-between">
    <div class="flex flex-col">

      <div class="min-h-[69px] shrink-0 flex flex-row justify-between gap-2">
        @if (!disableShowRecipeAction) {
        <div class="text-e-dark-green flex grow flex-col text-left cursor-pointer" (click)="showRecipeAction()">
          <ng-container *ngTemplateOutlet="recipeTitleSubtitle"></ng-container>
        </div>
        }@else {
        <a class="text-e-dark-green flex grow flex-col text-left" [routerLink]="[_recipe?.recipeurl]">
          <ng-container *ngTemplateOutlet="recipeTitleSubtitle"></ng-container>
        </a>
        }


        <favorites [entitytype]="'RECIPE'" [entityid]="_recipe?.id"></favorites>
      </div>

      @if (!condensed) {
      <div class="my-2.5 flex flex-row overflow-x-auto gap-2 ">
        <app-chip>
          <time class="text-sm">{{_recipe?.cookingtime}} {{'common.minutes_abbr' | translate}}</time>
        </app-chip>
        @if (getCalories(_recipe)) {
        <app-chip>
          <span class="text-sm">{{getCalories(_recipe)}} {{'unit_abbr.KILOCALORIES' | translate}}</span>
        </app-chip>
        }
        <app-chip>
          <span class="text-sm">{{_recipe?.vegetableweight |translate}} {{'unit_abbr.GRAM' |translate}} {{'recipe.vegetableweight'| translate}}</span>
          <!--<span class="text-sm">{{'recipe.difficulty-' + _recipe?.difficulty |translate}}</span>-->
        </app-chip>
      </div>

      <div class="mt-2.5 min-h-[63px] flex flex-row flex-wrap content-start items-start">
        @for (lifestyle of _recipe.lifestyles; track $index; let last = $last) {
        <small>{{getLifestyle(lifestyle?.lifestyleid)?.name | capitalizefirst}} @if (!last){, &nbsp;}</small>
        }
      </div>
      }
    </div>
    @if (!condensed) {
    <div class="flex flex-col">
      <div class="flex flex-row justify-between gap-2">
        @switch (_status) {
        @case ('PROCESSED') {
        @if (disableShowRecipeAction) {
        <a [routerLink]="[_recipe?.recipeurl]"
          class="button-base bg-e-reg-green text-e-dark-green w-full rounded-md hover:bg-e-dark-green hover:text-e-reg-green">{{'recipe.show_recipe' | translate}}</a>
        }@else {
        <a (click)="showRecipeAction()" class="button-base bg-e-reg-green text-e-dark-green w-full rounded-md hover:bg-e-dark-green hover:text-e-reg-green">{{'recipe.show_recipe' |
          translate}}</a>
        }
        }
        @case ('ONBOARD') {
        @if (disableShowRecipeAction) {
        <a [routerLink]="[_recipe?.recipeurl]" class="button-base bg-e-white text-e-dark-green w-full rounded-full hover:bg-e-light-green">{{'recipe.show_recipe' | translate}}</a>
        }@else {
        <a (click)="showRecipeAction()" class="button-base bg-e-white text-e-dark-green w-full rounded-full hover:bg-e-light-green">{{'recipe.show_recipe' | translate}}</a>
        }
        <a [routerLink]="['/personalmenu']" class="button-base w-full rounded-full bg-e-orange text-white hover:bg-e-light-green hover:text-e-dark-green">{{'recipe.order'
          |translate}}</a>
        }
        @case ('SELECTABLE') {
        <button [disabled]="loading" (click)="toggleSelection()" class="mr-2.5 w-full rounded-md md:w-3/5"
          [ngClass]="{'button-light' : _selected, 'button-mid text-e-mid-green bg-e-dark-green': !_selected}">
          {{(_selected? 'recipe.chosen': 'recipe.choose') | translate}}
        </button>
        @if (disableShowRecipeAction) {
        <a [routerLink]="[_recipe?.recipeurl]" class="button-mid my-auto w-full rounded-md text-center md:w-2/5"> <small> {{'recipe.more_info' | translate}}</small> </a>
        }@else {
        <button (click)="showRecipeAction()" class="button-clear w-full rounded-md md:w-2/5"> {{'recipe.more_info' | translate}} </button>
        }
        }
        @case ('PERSONEDITABLE') {
        <app-personselection class="w-full md:w-1/2 md:pe-2" [persons]="persons" (personsChange)="changePersons($event)">
          <span>{{'common.portions'|translate : {count: _recipe?.doublepersons? persons * 2 : persons } }}</span>
        </app-personselection>
        <button [disabled]="loading" (click)="toggleSelection()" class="w-full rounded-full md:w-1/2" [ngClass]="{'button-mid py-3' : _selected, 'button-cta': !_selected}">
          {{(_selected? 'recipe.added': 'recipe.add') | translate}}
        </button>
        }
        @default { <!--is empty for pauzings e.a.-->}

        }
      </div>
    </div>
    }
  </div>
</div>